import React from 'react';
import loadingIcon from 'assets/icons/loader.svg';

interface IconProps {
  label?: string,
  title?: string,
  alt?: string,
  src?: string,
  onClick?: () => void,
  disabled?: boolean,
  dynamic?: boolean,
  id?: string,
  'data-locator'?: string,
}

export const Icon = (props: IconProps) => {
  return <img
    id={props.id}
    data-locator={props['data-locator']}
    role={props.onClick ? 'button' : undefined}
    aria-label={props.label || props.title}
    className={`align-middle m-auto w-5 ${
      props.dynamic ? 'transition duration-200 cursor-pointer transform ease-in-out hover:scale-125' : ''} ${
      props.disabled ? 'opacity-50' : ''}`}
    title={props.title || props.label}
    onClick={() => {
      if (props.onClick && !props.disabled) props.onClick();
    }}
    src={props.src}
    alt={props.alt || props.title} />;
};

// Identical to Icon, but enforces that onClick must be provided.
export const IconButton = (props: IconProps & { onClick: () => void }) => {
  return <Icon {...{ ...props, dynamic: true }} />;
};

export const IconLoader = () => {
  return <img
    data-locator='loading'
    aria-label='Loading'
    className='align-middle m-auto w-5 animate-spin'
    title='Loading...'
    src={loadingIcon}
    alt='loading' />;
};
